export default __webpack_public_path__ + "static/media/2020_patent.a792871b.jpg";